import React from 'react';
import { Label, Icon } from 'semantic-ui-react';


const helpLinkStyle = {
  color: 'rgb(0, 181, 173)',
  fontWeight: 'bold',
};

const HelpLink = ({ url }) => (
  <Label as="a" color="teal" basic onClick="blah">
    <Icon name="help" />
    <a
      style={helpLinkStyle}
      target="_blank"
      rel="noopener noreferrer" href={url}
    >
        click here for help
    </a>
  </Label>
);

export default HelpLink;



/** WEBPACK FOOTER **
 ** ./src/components/help-link/index.js
 **/